// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * InvoiceGroupAttributes type.
 * @typedef {object} InvoiceGroupAttributes
 * @property {string} id - Attribute value.
 * @property {string | null} name - Attribute value.
 */
/**
 * Attributes accepted by InvoiceGroupCreateAttributes.
 * @typedef {object} InvoiceGroupCreateAttributes
 * @property {InvoiceGroupAttributes["name"] | null} [name] - Permitted name value.
 */
/**
 * Attributes accepted by InvoiceGroupUpdateAttributes.
 * @typedef {object} InvoiceGroupUpdateAttributes
 * @property {InvoiceGroupAttributes["name"] | null} [name] - Permitted name value.
 */
/**
 * Frontend model for InvoiceGroup.
 * @augments {FrontendModelBase<InvoiceGroupAttributes, InvoiceGroupCreateAttributes, InvoiceGroupUpdateAttributes, InvoiceGroupAttributes["id"], string>}
 */
class InvoiceGroup extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "InvoiceGroup",
      attributes: [
        "id",
        "name",
      ],
      collectionCommands: [
        "invoicesRoute",
      ],
    }
  }

  /** @returns {InvoiceGroupAttributes["id"]} - Attribute value. */
  id() { return /** @type {InvoiceGroupAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {InvoiceGroupAttributes["id"] | null} newValue - New attribute value.
   * @returns {InvoiceGroupAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {InvoiceGroupAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {InvoiceGroupAttributes["name"]} - Attribute value. */
  name() { return /** @type {InvoiceGroupAttributes["name"]} */ (this.readAttribute("name")) }

  /**
   * @param {InvoiceGroupAttributes["name"] | null} newValue - New attribute value.
   * @returns {InvoiceGroupAttributes["name"] | null} - Assigned value.
   */
  setName(newValue) { return /** @type {InvoiceGroupAttributes["name"] | null} */ (this.setAttribute("name", newValue)) }

  /**
   * Runs invoicesRoute.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{invoiceGroup: {id: string, name: string}}>} - Command response.
   */
  static async invoicesRoute(...commandArguments) {
    return /** @type {{invoiceGroup: {id: string, name: string}}} */ (await this.executeCustomCommand({
      commandName: "invoices-route",
      commandType: "invoices-route",
      payload: InvoiceGroup.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(InvoiceGroup)

export {InvoiceGroup}

export default InvoiceGroup
